import { Suspense } from "react"

import { Outlet, useLocation } from "react-router-dom"

import { appConfig } from "../../config"

import ChatWidget from "../../components/chat/ChatWidget"
import AppNavbar from "../../components/layout/AppNavbar"
import FooterBottom from "../../components/layout/FooterBottom"
import styled from "styled-components"

const HIDE_FOOTER_PATHS = ["/app/request", "/app/ongoing-trips"]

const AppHome = () => {
   const { pathname } = useLocation()
   const showFooter = !HIDE_FOOTER_PATHS.includes(pathname)

   return (
      <PageWrapper>
         <AppNavbar />
         <Main>
            <Outlet />
         </Main>
         {showFooter && (
            <>
               <Divider />
               <FooterBottom width="90%" theme="light" />
            </>
         )}
         {appConfig.features.aiChat && (
            <Suspense fallback={null}>
               <ChatWidget />
            </Suspense>
         )}
      </PageWrapper>
   )
}

export default AppHome

const PageWrapper = styled.div`
   display: flex;
   flex-direction: column;
   min-height: 100vh;
`

const Main = styled.main`
   flex: 1;
`

const Divider = styled.div`
   height: 1px;
   background: #e5e7eb;
   margin: 0;
`
